"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2928],{

/***/ 72122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30132);
/* harmony import */ var constants_typeText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25536);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  padding: 56px 0px 24px;\n\n  .typo {\n    font-weight: bold;\n    cursor: default;\n    font-size: 26px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ActivityListScreenHeaderDesktop = function(param) {
    var activityType = param.activityType, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
            className: "typo",
            children: constants_typeText__WEBPACK_IMPORTED_MODULE_2__/* .ACTIVITY_TYPE_TEXT */ .DK[activityType]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ActivityListScreenHeaderDesktop);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ActivityListScreenHeader.desktop__StyledWrapper",
    componentId: "sc-f055a5ff-0"
})(_templateObject());


/***/ }),

/***/ 22701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NU": function() { return /* binding */ PC_AD_CODE; },
/* harmony export */   "Q7": function() { return /* binding */ AD_CODE_ID; },
/* harmony export */   "s6": function() { return /* binding */ ACTIVITY_NOTICE_AD_CODE_ID; },
/* harmony export */   "xB": function() { return /* binding */ EDUCATION_RECOMMENDATION_AD_CODE_ID; }
/* harmony export */ });
/* unused harmony exports MOBILE_AD_CODE, ACTIVITY_NOTICE_AD_CODE */
var PC_AD_CODE;
(function(PC_AD_CODE) {
    PC_AD_CODE["MAIN"] = "pc-main-list-banner";
    PC_AD_CODE["HOTLINE"] = "pc-hotline-banner";
    PC_AD_CODE["RECOMMEND_ACTIVITY_S"] = "pc-recommend-activity-s-banner";
    PC_AD_CODE["RECOMMEND_ACTIVITY_A"] = "pc-recommend-activity-a-banner";
    PC_AD_CODE["WEEKLY_POPULAR"] = "pc-weekly-popular-activity";
    PC_AD_CODE["RECRUIT"] = "pc-recruit-banner";
    PC_AD_CODE["RIGHT_SIDEBAR"] = "pc-right-sidebar-all-of-page";
    PC_AD_CODE["HORIZONTAL"] = "web-activity-horizontal-ad";
    PC_AD_CODE["RECRUIT_QNA_BOTTOM"] = "pc-recruit-qna-bottom";
    PC_AD_CODE["COVER_LETTER_SEARCH"] = "pc-coverletter-search-banner";
    PC_AD_CODE["LIVE_ACTIVITY"] = "live-activity";
    PC_AD_CODE["FULLSCREEN_POPUP"] = "pc-full-popup";
    PC_AD_CODE["EDUCATION_TOP_PINNED_BANNER"] = "pc-education-top-pinned-banner";
})(PC_AD_CODE || (PC_AD_CODE = {}));
var MOBILE_AD_CODE;
(function(MOBILE_AD_CODE) {
    MOBILE_AD_CODE["MAIN"] = "mobile-main-list-banner";
    MOBILE_AD_CODE["HOTLINE"] = "mobile-hotline-banner";
    MOBILE_AD_CODE["RECOMMEND_ACTIVITY_S"] = "mobile-recommend-activity-s-banner";
    MOBILE_AD_CODE["RECOMMEND_ACTIVITY_A"] = "mobile-recommend-activity-a-banner";
    MOBILE_AD_CODE["WEEKLY_POPULAR"] = "mobile-weekly-popular-activity";
    MOBILE_AD_CODE["RECRUIT"] = "mobile-recruit-banner";
    MOBILE_AD_CODE["RECRUIT_QNA_BOTTOM"] = "mobile-recruit-qna-bottom";
    MOBILE_AD_CODE["COVER_LETTER_SEARCH"] = "mobile-coverletter-search-banner";
    MOBILE_AD_CODE["LIVE_ACTIVITY"] = "live-activity";
    MOBILE_AD_CODE["FULLSCREEN_POPUP"] = "mobile-full-popup";
    MOBILE_AD_CODE["EDUCATION_TOP_PINNED_BANNER"] = "mobile-education-top-pinned-banner";
})(MOBILE_AD_CODE || (MOBILE_AD_CODE = {}));
var AD_CODE_ID = {
    MAIN: {
        PC: PC_AD_CODE.MAIN,
        MOBILE: MOBILE_AD_CODE.MAIN
    },
    HOTLINE: {
        PC: PC_AD_CODE.HOTLINE,
        MOBILE: MOBILE_AD_CODE.HOTLINE
    },
    RECOMMEND_ACTIVITY_S: {
        PC: PC_AD_CODE.RECOMMEND_ACTIVITY_S,
        MOBILE: MOBILE_AD_CODE.RECOMMEND_ACTIVITY_S
    },
    RECOMMEND_ACTIVITY_A: {
        PC: PC_AD_CODE.RECOMMEND_ACTIVITY_A,
        MOBILE: MOBILE_AD_CODE.RECOMMEND_ACTIVITY_A
    },
    LIVE_ACTIVITY: {
        PC: PC_AD_CODE.LIVE_ACTIVITY,
        MOBILE: MOBILE_AD_CODE.LIVE_ACTIVITY
    },
    WEEKLY_POPULAR: {
        PC: PC_AD_CODE.WEEKLY_POPULAR,
        MOBILE: MOBILE_AD_CODE.WEEKLY_POPULAR
    },
    RECRUIT: {
        PC: PC_AD_CODE.RECRUIT,
        MOBILE: MOBILE_AD_CODE.RECRUIT
    },
    RIGHT_SIDEBAR: {
        PC: PC_AD_CODE.RIGHT_SIDEBAR
    },
    HORIZONTAL: {
        PC: PC_AD_CODE.HORIZONTAL
    },
    RECRUIT_QNA_BOTTOM: {
        PC: PC_AD_CODE.RECRUIT_QNA_BOTTOM,
        MOBILE: MOBILE_AD_CODE.RECRUIT_QNA_BOTTOM
    },
    COVER_LETTER_SEARCH: {
        PC: PC_AD_CODE.COVER_LETTER_SEARCH,
        MOBILE: MOBILE_AD_CODE.COVER_LETTER_SEARCH
    },
    FULLSCREEN_POPUP: {
        PC: PC_AD_CODE.FULLSCREEN_POPUP,
        MOBILE: MOBILE_AD_CODE.FULLSCREEN_POPUP
    },
    EDUCATION_TOP_PINNED_BANNER: {
        PC: PC_AD_CODE.EDUCATION_TOP_PINNED_BANNER,
        MOBILE: MOBILE_AD_CODE.EDUCATION_TOP_PINNED_BANNER
    }
};
var ACTIVITY_NOTICE_AD_CODE;
(function(ACTIVITY_NOTICE_AD_CODE) {
    ACTIVITY_NOTICE_AD_CODE["INTERN_NOTICE"] = "activity-intern-notice-banner";
    ACTIVITY_NOTICE_AD_CODE["RECRUIT_NOTICE"] = "activity-recruit-notice-banner";
    ACTIVITY_NOTICE_AD_CODE["ACTIVITY_NOTICE"] = "activity-activity-notice-banner";
    ACTIVITY_NOTICE_AD_CODE["CONTEST_NOTICE"] = "activity-contest-notice-banner";
    ACTIVITY_NOTICE_AD_CODE["EDUCATION_NOTICE"] = "activity-education-notice-banner";
})(ACTIVITY_NOTICE_AD_CODE || (ACTIVITY_NOTICE_AD_CODE = {}));
var ACTIVITY_NOTICE_AD_CODE_ID = {
    INTERN_NOTICE: ACTIVITY_NOTICE_AD_CODE.INTERN_NOTICE,
    RECRUIT_NOTICE: ACTIVITY_NOTICE_AD_CODE.RECRUIT_NOTICE,
    ACTIVITY_NOTICE: ACTIVITY_NOTICE_AD_CODE.ACTIVITY_NOTICE,
    CONTEST_NOTICE: ACTIVITY_NOTICE_AD_CODE.CONTEST_NOTICE,
    EDUCATION_NOTICE: ACTIVITY_NOTICE_AD_CODE.EDUCATION_NOTICE
};
var EDUCATION_RECOMMENDATION_AD_CODE_ID = {
    PC: "pc-education-random-banner",
    MOBILE: "mobile-education-random-banner"
};


/***/ }),

/***/ 98693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BJ": function() { return /* binding */ AD_IMPRESSION_THRESHOLD; },
/* harmony export */   "a0": function() { return /* binding */ TOTAL_AD_SLOTS; },
/* harmony export */   "qe": function() { return /* binding */ TOTAL_ACTIVITY_AD_SLOTS; }
/* harmony export */ });
var AD_IMPRESSION_THRESHOLD = 0.9;
var TOTAL_AD_SLOTS = 4;
var TOTAL_ACTIVITY_AD_SLOTS = 12;


/***/ }),

/***/ 80979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ ACTIVITY_GTM_EVENT; },
/* harmony export */   "c": function() { return /* binding */ GTM_EVENT; }
/* harmony export */ });
/**
 * 광고 영역별 GTM 이벤트 정의
 */ var GTM_EVENT = {
    MAIN: {
        PC: {
            CLICK_EVENT: "pc_main_list_bnr_clk",
            IMPRESSION_EVENT: "pc_main_list_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_main_list_bnr_clk",
            IMPRESSION_EVENT: "mo_main_list_bnr_imp"
        }
    },
    HOTLINE: {
        PC: {
            CLICK_EVENT: "pc_hotline_bnr_clk",
            IMPRESSION_EVENT: "pc_hotline_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_hotline_bnr_clk",
            IMPRESSION_EVENT: "mo_hotline_bnr_imp"
        }
    },
    RECOMMEND_ACTIVITY_S: {
        PC: {
            CLICK_EVENT: "pc_rec_act_s_bnr_clk",
            IMPRESSION_EVENT: "pc_rec_act_s_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_rec_act_s_bnr_clk",
            IMPRESSION_EVENT: "mo_rec_act_s_bnr_imp"
        }
    },
    RECOMMEND_ACTIVITY_A: {
        PC: {
            CLICK_EVENT: "pc_rec_act_a_bnr_clk",
            IMPRESSION_EVENT: "pc_rec_act_a_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_rec_act_a_bnr_clk",
            IMPRESSION_EVENT: "mo_rec_act_a_bnr_imp"
        }
    },
    WEEKLY_POPULAR: {
        PC: {
            CLICK_EVENT: "pc_wkly_pop_act_clk",
            IMPRESSION_EVENT: "pc_wkly_pop_act_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_wkly_pop_act_clk",
            IMPRESSION_EVENT: "mo_wkly_pop_act_imp"
        }
    },
    RECRUIT: {
        PC: {
            CLICK_EVENT: "pc_rec_bnr_clk",
            IMPRESSION_EVENT: "pc_rec_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_rec_bnr_clk",
            IMPRESSION_EVENT: "mo_rec_bnr_imp"
        }
    },
    RIGHT_SIDEBAR: {
        PC: {
            CLICK_EVENT: "pc_rgt_side_all_pg_clk",
            IMPRESSION_EVENT: "pc_rgt_side_all_pg_imp"
        }
    },
    HORIZONTAL: {
        PC: {
            CLICK_EVENT: "pc_horz_ad_clk",
            IMPRESSION_EVENT: "pc_horz_ad_imp"
        }
    },
    RECRUIT_QNA_BOTTOM: {
        PC: {
            CLICK_EVENT: "pc_rec_qna_btm_clk",
            IMPRESSION_EVENT: "pc_rec_qna_btm_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_rec_qna_btm_clk",
            IMPRESSION_EVENT: "mo_rec_qna_btm_imp"
        },
        APP: {
            CLICK_EVENT: "app_rec_qna_btm_clk",
            IMPRESSION_EVENT: "app_rec_qna_btm_imp"
        }
    },
    COVER_LETTER_SEARCH: {
        PC: {
            CLICK_EVENT: "pc_cvlt_srch_bnr_clk",
            IMPRESSION_EVENT: "pc_cvlt_srch_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_cvlt_srch_bnr_clk",
            IMPRESSION_EVENT: "mo_cvlt_srch_bnr_imp"
        },
        APP: {
            CLICK_EVENT: "app_cvlt_srch_bnr_clk",
            IMPRESSION_EVENT: "app_cvlt_srch_bnr_imp"
        }
    },
    LIVE_ACTIVITY: {
        PC: {
            CLICK_EVENT: "pc_live_act_clk",
            IMPRESSION_EVENT: "pc_live_act_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_live_act_clk",
            IMPRESSION_EVENT: "mo_live_act_imp"
        }
    },
    FULLSCREEN_POPUP: {
        PC: {
            CLICK_EVENT: "pc_full_pop_clk",
            IMPRESSION_EVENT: "pc_full_pop_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_full_pop_clk",
            IMPRESSION_EVENT: "mo_full_pop_imp"
        }
    },
    EDUCATION_TOP_PINNED_BANNER: {
        PC: {
            CLICK_EVENT: "pc_edu_top_pinned_bnr_clk",
            IMPRESSION_EVENT: "pc_edu_top_pinned_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_edu_top_pinned_bnr_clk",
            IMPRESSION_EVENT: "mo_edu_top_pinned_bnr_imp"
        },
        APP: {
            IMPRESSION_EVENT: "app_edu_top_pinned_bnr_imp",
            CLICK_EVENT: "app_edu_top_pinned_bnr_clk"
        }
    }
};
var ACTIVITY_GTM_EVENT = {
    INTERN_NOTICE: {
        PC: {
            IMPRESSION_EVENT: "pc_int_ntc_bnr_imp",
            CLICK_EVENT: "pc_int_ntc_bnr_clk"
        },
        MOBILE: {
            IMPRESSION_EVENT: "mo_int_ntc_bnr_imp",
            CLICK_EVENT: "mo_int_ntc_bnr_clk"
        }
    },
    RECRUIT_NOTICE: {
        PC: {
            IMPRESSION_EVENT: "pc_rec_ntc_bnr_imp",
            CLICK_EVENT: "pc_rec_ntc_bnr_clk"
        },
        MOBILE: {
            IMPRESSION_EVENT: "mo_rec_ntc_bnr_imp",
            CLICK_EVENT: "mo_rec_ntc_bnr_clk"
        }
    },
    ACTIVITY_NOTICE: {
        PC: {
            IMPRESSION_EVENT: "pc_act_ntc_bnr_imp",
            CLICK_EVENT: "pc_act_ntc_bnr_clk"
        },
        MOBILE: {
            IMPRESSION_EVENT: "mo_act_ntc_bnr_imp",
            CLICK_EVENT: "mo_act_ntc_bnr_clk"
        }
    },
    CONTEST_NOTICE: {
        PC: {
            IMPRESSION_EVENT: "pc_ctst_ntc_bnr_imp",
            CLICK_EVENT: "pc_ctst_ntc_bnr_clk"
        },
        MOBILE: {
            IMPRESSION_EVENT: "mo_ctst_ntc_bnr_imp",
            CLICK_EVENT: "mo_ctst_ntc_bnr_clk"
        }
    },
    EDUCATION_NOTICE: {
        PC: {
            IMPRESSION_EVENT: "pc_edu_ntc_bnr_imp",
            CLICK_EVENT: "pc_edu_ntc_bnr_clk"
        },
        MOBILE: {
            IMPRESSION_EVENT: "mo_edu_ntc_bnr_imp",
            CLICK_EVENT: "mo_edu_ntc_bnr_clk"
        },
        APP: {
            IMPRESSION_EVENT: "app_edu_ntc_bnr_imp",
            CLICK_EVENT: "app_edu_ntc_bnr_clk"
        }
    }
};


/***/ }),

/***/ 59037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RightSideBarBannerStatus_desktop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.components/Skeleton.tsx
var Skeleton = __webpack_require__(96679);
// EXTERNAL MODULE: ./src/app.feature/ad/constants/adCode.ts
var adCode = __webpack_require__(22701);
// EXTERNAL MODULE: ./src/app.feature/ad/hooks/useGetAdByPlacementCodeAndCurrentTime.ts
var useGetAdByPlacementCodeAndCurrentTime = __webpack_require__(68545);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/app.feature/ad/constants/gtm.ts
var gtm = __webpack_require__(80979);
// EXTERNAL MODULE: ./src/app.feature/ad/hooks/useAdImpressionTracker.ts
var useAdImpressionTracker = __webpack_require__(69784);
// EXTERNAL MODULE: ./src/app.feature/ad/modules/gtmEvents.ts
var gtmEvents = __webpack_require__(24033);
// EXTERNAL MODULE: ./src/utils/optimizeImageUrl.ts
var optimizeImageUrl = __webpack_require__(65342);
;// CONCATENATED MODULE: ./src/app.feature/ad/desktop/AllCoverBanner/RightSideBarBanner/RightSideBarBanner.desktop.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 614px;\n  left: calc(100% + 20px);\n  width: 160px;\n  height: 600px;\n  .right-sidebar-banner-image {\n    border-radius: 5px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var RIGHT_SIDEBAR_BANNER_PC_IMAGE_SIZE = {
    width: 160,
    height: 600
};
var RightSideBarBannerDesktop = function(param) {
    var ad = param.ad, className = param.className;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    (0,useAdImpressionTracker/* default */.Z)({
        eventName: gtm/* GTM_EVENT.RIGHT_SIDEBAR.PC.IMPRESSION_EVENT */.c.RIGHT_SIDEBAR.PC.IMPRESSION_EVENT,
        campaignId: (ref = ad.campaign) === null || ref === void 0 ? void 0 : ref.id
    });
    var handleClickOutLink = function() {
        var ref, ref1;
        (0,gtmEvents/* pushGTMCampaignId */.h)({
            eventName: gtm/* GTM_EVENT.RIGHT_SIDEBAR.PC.CLICK_EVENT */.c.RIGHT_SIDEBAR.PC.CLICK_EVENT,
            campaignId: ((ref = ad.campaign) === null || ref === void 0 ? void 0 : ref.id) || ""
        });
        if ((ref1 = ad.campaign) === null || ref1 === void 0 ? void 0 : ref1.landingURL) {
            window.open(ad.campaign.landingURL, "_blank", "noopener, noreferrer");
        }
    };
    var activityUrl = ((ref1 = ad.activity) === null || ref1 === void 0 ? void 0 : ref1.id) ? "/activity/".concat((ref2 = ad.activity) === null || ref2 === void 0 ? void 0 : ref2.id) : "";
    var alt = (ad === null || ad === void 0 ? void 0 : (ref3 = ad.campaign) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.campaignGroup) === null || ref4 === void 0 ? void 0 : ref4.name) ? "".concat(ad === null || ad === void 0 ? void 0 : (ref5 = ad.campaign) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.campaignGroup) === null || ref6 === void 0 ? void 0 : ref6.name, " 우측 사이드바 배너 이미지") : "우측 사이드바 배너 이미지";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        className: className,
        onClick: handleClickOutLink,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: activityUrl,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                rel: "nofollow sponsored",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: "right-sidebar-banner-image",
                    alt: alt,
                    width: RIGHT_SIDEBAR_BANNER_PC_IMAGE_SIZE.width,
                    height: RIGHT_SIDEBAR_BANNER_PC_IMAGE_SIZE.height,
                    loader: optimizeImageUrl/* imageLoader */.X,
                    src: (0,optimizeImageUrl/* optimizeImageUrl */.m)({
                        url: (ref7 = ad.image) === null || ref7 === void 0 ? void 0 : ref7.url,
                        width: RIGHT_SIDEBAR_BANNER_PC_IMAGE_SIZE.width,
                        height: RIGHT_SIDEBAR_BANNER_PC_IMAGE_SIZE.height
                    })
                }, "right-sidebar-banner-image")
            })
        })
    });
};
/* harmony default export */ var RightSideBarBanner_desktop = (RightSideBarBannerDesktop);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RightSideBarBanner.desktop__StyledWrapper",
    componentId: "sc-805fd1ed-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/ad/desktop/AllCoverBanner/RightSideBarBanner/RightSideBarBannerStatus.desktop.tsx

function RightSideBarBannerStatus_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 614px;\n  left: calc(100% + 20px);\n  width: 160px;\n  height: 600px;\n"
    ]);
    RightSideBarBannerStatus_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var RightSideBarBannerStatusDesktop = function(param) {
    var className = param.className;
    var ref = (0,useGetAdByPlacementCodeAndCurrentTime/* default */.Z)({
        code: adCode/* PC_AD_CODE.RIGHT_SIDEBAR */.NU.RIGHT_SIDEBAR
    }), ad = ref.ad, loading = ref.loading, error = ref.error;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper, {
            className: className
        });
    }
    if (error || !ad) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RightSideBarBanner_desktop, {
        className: className,
        ad: ad
    });
};
/* harmony default export */ var RightSideBarBannerStatus_desktop = (/*#__PURE__*/(0,react.memo)(RightSideBarBannerStatusDesktop));
var SkeletonWrapper = (0,styled_components_browser_esm/* default */.ZP)(Skeleton/* default */.Z).withConfig({
    displayName: "RightSideBarBannerStatus.desktop__SkeletonWrapper",
    componentId: "sc-bcc5720b-0"
})(RightSideBarBannerStatus_desktop_templateObject());


/***/ }),

/***/ 69784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _modules_gtmEvents__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24033);


/**
 * 광고 impression 이벤트를 추적하는 커스텀 훅
 * 매 렌더링마다 이벤트를 발생시킵니다.
 */ var useAdImpressionTracker = function(param) {
    var eventName = param.eventName, campaignId = param.campaignId;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (campaignId) {
            (0,_modules_gtmEvents__WEBPACK_IMPORTED_MODULE_1__/* .pushGTMCampaignId */ .h)({
                eventName: eventName,
                campaignId: campaignId
            });
        }
    }, []);
};
/* harmony default export */ __webpack_exports__["Z"] = (useAdImpressionTracker);


/***/ }),

/***/ 82138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47079);
/* harmony import */ var constants_enums__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35460);



var useGetActivityListFromAdsByPlacementCode = function(param) {
    var adPlacementCode = param.adPlacementCode, restVariables = param.restVariables, activityTypeID = param.activityTypeID;
    var noticeBannerQueryVariables = {
        isEducation: activityTypeID === constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.EDUCATION */ .kF.EDUCATION,
        isRecruit: activityTypeID === constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT || activityTypeID === constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.INTERN */ .kF.INTERN,
        isActivity: activityTypeID === constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY || activityTypeID === constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CONTEST */ .kF.CONTEST
    };
    var ref = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .useGqlActivityListFromAdsByPlacementCodeQuery */ .PTF)({
        variables: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            adPlacementCode: adPlacementCode
        }, restVariables && restVariables, noticeBannerQueryVariables)
    }), data = ref.data, loading = ref.loading, error = ref.error;
    return {
        ads: data === null || data === void 0 ? void 0 : data.activityListFromAdsByPlacementCode,
        loading: loading,
        error: error
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetActivityListFromAdsByPlacementCode);


/***/ }),

/***/ 68545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32912);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47079);




/**
 * 단일한 랜덤의 광고 지면을 응답받아야 하는 경우 사용합니다.
 * @param  TUseGetAdByPlacementCodeAndCurrentTimeParams
 * @returns
 */ var useGetAdByPlacementCodeAndCurrentTime = function(param) {
    var code = param.code;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var page = router.query.page;
    var currentTime = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var currentDate = new Date();
        return (0,date_fns_format__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(currentDate, "HH:mm:ss");
    }, [
        page
    ]);
    var ref = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .useGqlCurrentAdByPlacementCodeAndCurrentTimeQuery */ .hf9)({
        variables: {
            code: code,
            currentTime: currentTime
        }
    }), data = ref.data, loading = ref.loading, error = ref.error;
    return {
        ad: data === null || data === void 0 ? void 0 : data.currentAdByPlacementCodeAndCurrentTime,
        loading: loading,
        error: error
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetAdByPlacementCodeAndCurrentTime);


/***/ }),

/***/ 24033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ pushGTMCampaignId; }
/* harmony export */ });
/**
 * Campaign ID를 포함한 GTM 이벤트를 발생시키는 함수
 * window.dataLayer가 존재할 경우 이벤트를 push합니다.
 *
 * @param eventName - GTM에서 트리거로 사용될 이벤트 이름
 * @param campaignId - 캠페인 ID
 * @example
 * pushGTMCampaignId({
 *   eventName: 'view_campaign',
 *   campaign_id: '12345'
 * })
 */ var pushGTMCampaignId = function(param) {
    var eventName = param.eventName, campaignId = param.campaignId;
    if (!(window === null || window === void 0 ? void 0 : window.dataLayer) || !campaignId || !eventName) {
        return;
    }
    window.dataLayer.push({
        event: eventName,
        campaign_id: campaignId
    });
};


/***/ }),

/***/ 76318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41120);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);








var useStyle = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
    return {
        greyButton: {
            color: "white",
            backgroundColor: "#bbbbbb",
            "&:hover": {
                boxShadow: "none",
                backgroundColor: "#aaaaaa"
            },
            "&:focus": {
                boxShadow: "none"
            }
        }
    };
});
var Button = function(props) {
    var classesProp = props.classes, className = props.className, tmp = props.color, colorProp = tmp === void 0 ? "default" : tmp, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "classes",
        "className",
        "color"
    ]);
    var classes = useStyle();
    var color = colorProp === "grey" ? "default" : colorProp;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        color: color
    }, buttonProps), {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, classes.greyButton, colorProp === "grey"), className),
        disableElevation: true,
        classes: classesProp
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ })

}]);